import ApiService from "src/util/api.service";
import { getLanguageHeaders } from "src/services/commonLanguageHeader";
import { ServicesUrlEndpoints } from "src/services/servicesEndpointConstant";

export type TireModelSortDirection = "ASC" | "DESC";

export interface TireModelListParams {
  page?: number;
  size?: number;
  sort?: TireModelSortDirection;
  sortBy?: string;
}

export interface TireModelRecord {
  id: string | number;
  name?: string;
  description?: string;
  active?: boolean | number | string;
  [key: string]: unknown;
}

export interface TireModelPayload {
  active: boolean;
  description?: string;
  idMake?: string | number;
  name: string;
}

export interface TireModelStatusPayload extends Partial<TireModelPayload> {
  id: string | number;
  active: boolean;
  [key: string]: unknown;
}

export interface TireModelPaginatedResponse {
  resources?: TireModelRecord[];
  tireModels?: TireModelRecord[];
  data?: TireModelRecord[];
  items?: TireModelRecord[];
  content?: TireModelRecord[];
  totalItems?: number;
  totalElements?: number;
  total?: number;
}

const replaceId = (url: string, id: string | number) => url.replace("{id}", String(id));

export const getTireModelsList = (params: TireModelListParams = {}, language?: string) =>
  ApiService.get<{ response: TireModelPaginatedResponse }>(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MODELS.LISTING,
    {
      params,
      ...getLanguageHeaders(language),
    }
  );

export const getTireModelById = (id: string | number, language?: string) =>
  ApiService.get<{ response: TireModelRecord }>(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MODELS.GET, id),
    getLanguageHeaders(language)
  );

export const createTireModel = (payload: TireModelPayload, language?: string) =>
  ApiService.post(
    ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MODELS.ADD,
    payload,
    getLanguageHeaders(language)
  );

export const updateTireModel = (
  id: string | number,
  payload: TireModelPayload & { id: string | number },
  language?: string
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MODELS.UPDATE, id),
    payload,
    getLanguageHeaders(language)
  );

export const updateTireModelStatus = (
  id: string | number,
  payload: TireModelStatusPayload,
  language?: string
) =>
  ApiService.patch(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MODELS.UPDATE, id),
    payload,
    getLanguageHeaders(language)
  );

export const deleteTireModel = (id: string | number, language?: string) =>
  ApiService.delete(
    replaceId(ServicesUrlEndpoints.ADMINISTRATION.SETUP.TIRE_MODELS.DELETE, id),
    getLanguageHeaders(language)
  );
